import { toast } from "react-toastify";
import { TOAST_CONFIG } from "./toastConfig";

// navigator.clipboard saknas helt i osäker kontext och kan dessutom nekas av
// användaren. Utan fångst blir ett misslyckande tyst, vilket är illa när texten
// bara visas en gång - då tror användaren att den är kopierad.
export const copyToClipboard = async (text, intl) => {
  try {
    if (!navigator.clipboard) {
      throw new Error("Clipboard API unavailable");
    }

    await navigator.clipboard.writeText(text);

    return true;
  } catch {
    toast.warn(intl.formatMessage({ id: "CopyFailed" }), TOAST_CONFIG);

    return false;
  }
};
